<div class="btn-group" container="body" ngbDropdown role="group" aria-label="Button group with nested dropdown">
  <button class="btn btn-link float-right dropdown-no-arrow" ngbDropdownToggle title="Contact Actions">
    <span class="fa-solid fa-ellipsis-vertical"></span>
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <button ngbDropdownItem #deleteButton
            [disabled]="(!isAdminRole && !isSuperAdminRole)"
            [ngClass]="{'text-danger': !deleteButton.classList.contains('disabled')}"
            (click)="onDeleteContact(contact)">
      <span class="fa-solid fa-trash"></span>
      <span translate>Delete support contact</span></button>
    <button ngbDropdownItem
            [disabled]="(!isAdminRole && !isSuperAdminRole)"
            (click)="onEditContact(contact)">
      <span class="fa-solid fa-pen"></span>
      <span translate>Edit support contact</span>
    </button>

  </div>
</div>
